export default {
  install(Vue, options) {
    Vue.prototype.$mapToSelect = (
      collection,
      title,
      disabled = [],
      selected = []
    ) => {
      return collection.map(item => {
        if (title instanceof Array) {
          let temp_item = item;
          for (const key in title) {
            temp_item = temp_item[title[key]];
          }
          item.text = temp_item;
        } else {
          item.text = item[title];
        }
        selected.forEach(select => {
          if (item.id == select) {
            item.selected = true;
          }
        });
        disabled.forEach(disable => {
          if (item.id == disable) {
            item.disabled = true;
          }
        });
        return item;
      });
    };
    Vue.prototype.$convertDate = (date, separator = '-', revert = true) => {
      const old_date = new Date(date);
      let month = '' + (old_date.getMonth() + 1);
      let day = '' + old_date.getDate();
      const year = old_date.getFullYear();
      if (day.length < 2) {
        day = '0' + day;
      }
      if (month.length < 2) {
        month = '0' + month;
      }
      let new_date = '';
      if (revert) {
        new_date = day + separator + month + separator + year;
      } else {
        new_date = year + separator + month + separator + day;
      }
      return new_date;
    };

    Vue.prototype.$convertDateAndTime = (
      date,
      separatortime = '-',
      revert = true
    ) => {
      const old_date = new Date(date);
      let month = '' + (old_date.getMonth() + 1);
      let day = '' + old_date.getDate();
      const year = old_date.getFullYear();
      if (day.length < 2) {
        day = '0' + day;
      }
      if (month.length < 2) {
        month = '0' + month;
      }

      const time = date.substr(11, 5);

      let new_date = '';
      if (revert) {
        new_date =
          day + separatortime + month + separatortime + year + '/' + time;
      } else {
        new_date = year + separatortime + month + separatortime + day;
      }
      return new_date;
    };

    Vue.prototype.$convertTime = (date, separator = ':', revert = false) => {
      const old_date = new Date(date);
      let minutes = old_date.getMinutes();
      const hours = old_date.getHours();

      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      const new_date = hours + separator + minutes;
      return new_date;
    };
    Vue.prototype.$onlyData = data => {
      return _.cloneDeep(data);
    };
    Vue.prototype.$copyText = text => {
      const input = document.createElement('input');
      input.style.height = '0px';
      document.body.appendChild(input);
      input.value = text;
      input.select();
      input.setSelectionRange(0, 99999);
      document.execCommand('copy');
      input.remove();
    };
  }
};
